module.exports = __webpack_public_path__ + "static/media/syncui_121.be6bfc96.ico";